<template>
  <div
    class="flex justify-between w-full items-center px-5 py-4 bg-pitch-black rounded-md shadow-md border-b-2 border-total-white-300"
    @click="viewContact"
  >
    <!-- Avatar and Contact Info -->
    <div class="flex gap-2 items-center">
      <div
        class="w-12 h-12 rounded-full mr-4 flex items-center justify-center bg-light-grey-translucent-dark border border-light-grey-translucent-dark overflow-hidden"
      >
        <template v-if="avatar">
          <img
            :src="avatar"
            alt="Avatar"
            class="w-full h-full rounded-full object-cover"
          />
        </template>
        <template v-else>
          <!-- Placeholder icon -->
          <i class="fa-solid fa-user text-4xl text-pitch-black -mb-[1px] mt-auto"></i>
        </template>
      </div>
      <div class="text-left">
        <h3 class="text-white font-semibold text-lg">{{ name }} <span v-if="role === 'Project Manager'">(You)</span></h3>
        <p class="text-gray-400 text-sm">{{ role }}</p>
      </div>
    </div>

    <div class="flex gap-5">
      <template v-if="role === 'Project Manager'">
        <button @click="copyDetails($event)">
          <i class="fa fa-copy text-2xl text-prime-golden fa-regular mt-1"></i>
        </button>
      </template>
      <!-- Options Button -->
      <button @click.stop="optionsClicked">
        <img src="../assets/images/elipsis-icon.svg" class="w-6" alt="contact info" />
      </button>
    </div>
  </div>
</template>

<script>
import { useToast } from "vue-toastification";

export default {
  props: {
    contactId: {
      type: [String, Number],
      required: true,
    },
    avatar: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    role: {
      type: String,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
  },
  setup(props, { emit }) {
    const toast = useToast();

    const optionsClicked = (event) => {
      event.stopPropagation();
      emit("optionsClicked", props.contactId);
    };

    const viewContact = () => {
      emit("viewContact", props.contactId);
    };

    const copyDetails = (event) => {
      event.stopPropagation();
      const formattedText = `${props.name.replace(' (Me)', '').replace(' (You)', '')}: ${props.phoneNumber}`;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(formattedText).then(() => {
          toast.success('Contact details copied to clipboard.');
        }).catch(err => {
          console.error('Failed to copy contact details: ', err);
          toast.error('Failed to copy contact details.');
        });
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = formattedText;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        toast.success('Contact details copied to clipboard.');
      }
    };

    return {
      optionsClicked,
      viewContact,
      copyDetails,
    };
  },
};
</script>
